import { Capacitor } from '@capacitor/core';

/**
 * True inside the native iOS/Android shell.
 *
 * Works even though the shell loads the remote https://turaq.kg build
 * (capacitor.config.ts -> server.url): Capacitor injects its native bridge
 * into the WebView before any app code runs, so the very same deployed bundle
 * can tell "app" from "site" at runtime.
 */
export const isNativeApp = (): boolean => Capacitor.isNativePlatform();

/**
 * Sign in with Apple — only in the iOS app for now.
 *
 * - iOS app: mandatory (App Review Guideline 4.8 — required whenever another
 *   third-party login is offered), so it stays there.
 * - Website / Android: hidden. Google is the one-tap way in; the Apple button
 *   next to it split taps and Apple on the web still depends on the Services
 *   ID return URL. To bring it back on the site, swap the two lines below.
 */
// export const isAppleSignInAvailable = (): boolean => true;
export const isAppleSignInAvailable = (): boolean =>
  Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios';
